import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { NotFoundRoutingModule } from './not-found-routing.module';

@NgModule({
  imports: [SharedModule, RouterModule, CommonModule, NotFoundRoutingModule],
  exports: [],
  providers: []
})
export class NotFoundModule {}
